export const MIN_SCALE = 0.5
export const DEFAULT_SCALE = 1.5

export const rotateImg = (
    counterClockwise: boolean,
    rotationDegree: number,
) => {
    const ROTATE_90_DEGREES = 90
    const FULL_CIRCLE = 360

    let newRotation = rotationDegree

    if (counterClockwise) {
        newRotation += ROTATE_90_DEGREES
    } else {
        newRotation -= ROTATE_90_DEGREES
    }
    if (newRotation >= FULL_CIRCLE) {
        newRotation = 0
    }
    if (newRotation < 0) {
        newRotation = FULL_CIRCLE - ROTATE_90_DEGREES
    }

    return newRotation
}

export const handleRotationDegreeForInspectionDocument = (
    counterClockwise: boolean,
    inspectionDocumentId: number,
    rotationDegree: number,
    rotationDegreeInspectionDocument: {
        [x: number]: number
    },
    setRotationDegreeInspectionDocument: Function,
) => {
    const rotation = rotationDegreeInspectionDocument[inspectionDocumentId]
    const rotatedInspectionDocument = rotationDegreeInspectionDocument

    if (rotationDegree !== undefined) {
        rotatedInspectionDocument[inspectionDocumentId] = rotation
            ? rotateImg(counterClockwise, rotation)
            : rotateImg(counterClockwise, rotationDegree)
        return setRotationDegreeInspectionDocument({
            ...rotatedInspectionDocument,
        })
    }

    if (rotation !== undefined) {
        rotatedInspectionDocument[inspectionDocumentId] = rotation
    }

    return setRotationDegreeInspectionDocument({ ...rotatedInspectionDocument })
}

export const handleZoomScale = (
    zoomIn: boolean,
    inspectionDocumentId: number,
    zoomScale: { [x: number]: number },
    setZoomScale: Function,
) => {
    const zoomScaleTemp = zoomScale[inspectionDocumentId]

    zoomScale[inspectionDocumentId] = zoomIn
        ? zoomScaleTemp
            ? zoomScaleTemp + MIN_SCALE
            : DEFAULT_SCALE
        : zoomScaleTemp
        ? zoomScaleTemp - MIN_SCALE
        : MIN_SCALE

    return setZoomScale({ ...zoomScale })
}
